/* TonePreviewButton.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./TonePreviewButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef, memo } from 'react';
import { B100 } from '@atlaskit/theme/colors';
import Emoji from './Emoji';
export var tonePreviewTestId = 'tone-preview';
var emojiButton = null;
var hidden = null;
export var TonePreviewButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var emoji = props.emoji,
    selectOnHover = props.selectOnHover,
    ariaLabelText = props.ariaLabelText,
    ariaExpanded = props.ariaExpanded,
    onSelected = props.onSelected,
    _props$isVisible = props.isVisible,
    isVisible = _props$isVisible === void 0 ? true : _props$isVisible;
  return /*#__PURE__*/React.createElement("button", {
    ref: ref,
    onClick: onSelected,
    "aria-label": ariaLabelText,
    "aria-expanded": ariaExpanded,
    "aria-controls": "emoji-picker-tone-selector"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,

    "data-testid": tonePreviewTestId,
    type: "button",
    className: ax(["_19itidpf _2rkofajl _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _80omtlke _kqswh2mm _1e0c1o8l _lev4idpf _1cx6idpf _tyukidpf _2ewlidpf _11bcidpf _dqozglyw _1at812x7 _1cjo12x7 _1yg612x7 _hjaq12x7 _hlt21tcg _1s3c1tcg _1i911tcg _1ye71tcg _nt751r31 _49pcglyw _1hvw1o36 _7ehi1r2v _491113zc", !isVisible && "_tzy4idpf _3um015vq _1e0cglyw"]),
    style: {
      overflow: 'hidden',
      "--_1rebzxw": ix("0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")))
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: emoji,
    selectOnHover: selectOnHover,
    shouldBeInteractive: false,
    "aria-hidden": true
  }));
});
export default /*#__PURE__*/memo(TonePreviewButton);